<template>
    <div class="min-h-screen bg-gray-50 flex flex-col md:flex-row">
        <div class="flex-grow-0 relative">
            <img :src="asset('img/onboarding-bg.jpg')" class="absolute inset-0 h-full w-full object-cover object-left-top" />

            <div class="relative z-10 flex justify-center py-5 sm:min-w-[400px]">
                <app-logo></app-logo>
            </div>
        </div>

        <div class="flex-1 relative">
            <div class="container h-full flex flex-col items-center justify-center">
                <div class="w-full py-10">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLogo from '@Components/ApplicationLogo'

export default {
    components: {
        AppLogo
    },
    props: {

    }
}
</script>

<style>

</style>
